const getSpeakerSlug = (name) => name.split(' ').join('_');

export default getSpeakerSlug;